export function currentSlimmerId(state) {
  return state.session.currentSlimmerId
}

export function isSignedIn(state) {
  return !! currentSlimmerId(state)
}
